// src/components/ErrorPage.jsx
import { useRouteError } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { usePostHog } from '@posthog/react';

export default function ErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();
  const posthog = usePostHog();

  // Extract useful error information
  const errorMessage = error?.message || error?.statusText || 'Unknown error occurred';
  const errorStatus = error?.status || '';

  posthog?.captureException(error instanceof Error ? error : new Error(errorMessage));

  return (
    <div 
      className="error-page" 
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        fontFamily: 'Arial, sans-serif'
      }}
    >
      <div 
        style={{
          maxWidth: '600px',
          width: '100%',
          background: 'white',
          borderRadius: '8px',
          padding: '30px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
        }}
      >
        <h1 
          style={{ 
            color: '#dc3545',
            marginBottom: '20px',
            fontSize: '2.5rem'
          }}
        >
          {errorStatus ? `${errorStatus} - Oops!` : 'Oops!'}
        </h1>
        
        <p style={{ color: '#333', fontSize: '1.1rem', marginBottom: '20px' }}>
          Sorry, something went wrong. We couldn't complete your request. You can send a mail to contact@fablia.fr to inform us about this error.
        </p>
        
        <p 
          style={{ 
            color: '#666', 
            fontStyle: 'italic',
            marginBottom: '30px',
            wordBreak: 'break-word'
          }}
        >
          Error: {errorMessage}
        </p>

        <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
          <button
            onClick={() => navigate('/')}
            style={{
              padding: '10px 20px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '1rem',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={e => e.target.style.backgroundColor = '#0056b3'}
            onMouseOut={e => e.target.style.backgroundColor = '#007bff'}
          >
            Go to Homepage
          </button>
          
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 20px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '1rem',
              transition: 'background-color 0.2s'
            }}
            onMouseOver={e => e.target.style.backgroundColor = '#5a6268'}
            onMouseOut={e => e.target.style.backgroundColor = '#6c757d'}
          >
            Try Again
          </button>
        </div>

        {/* Show detailed error info only in development */}
        {import.meta.env.DEV && (
          <details 
            style={{ 
              marginTop: '30px',
              border: '1px solid #eee',
              padding: '15px',
              borderRadius: '5px'
            }}
          >
            <summary 
              style={{ 
                cursor: 'pointer',
                color: '#007bff',
                marginBottom: '10px'
              }}
            >
              Technical Details
            </summary>
            <pre 
              style={{ 
                color: '#dc3545',
                fontSize: '0.9rem',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word'
              }}
            >
              {JSON.stringify(
                {
                  message: errorMessage,
                  status: errorStatus,
                  stack: error?.stack,
                },
                null,
                2
              )}
            </pre>
          </details>
        )}
      </div>

      <footer 
        style={{ 
          marginTop: '20px',
          color: '#666',
          fontSize: '0.9rem'
        }}
      >
        If this problem persists, please contact support.
      </footer>
    </div>
  );
}